module.exports = __webpack_public_path__ + "img/dashed_06.e4e17262.png";